import PlannerDriverPlanListRequest from "../../api/raily/planner/list/planner-driver-plan-list.request";
import PlannerDriverPlanOrderRequest from "../../api/raily/planner/order/planning-driver-plan-order.request";
import plannerApiService from "../../api/raily/planner/planner-driver-plan-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import PlannerDriverPlanList from "./list/planner-driver-plan-list";
import PlannerDriverPlanListError from "./list/planner-driver-plan-list-error";
import PlannerDriverPlanListParams from "./list/planner-driver-plan-list-params";
import plannerRequestFactory from "./list/planner-driver-plan-list-params.factory";
import plannerDriverPlanListFactory from "./list/planner-driver-plan-list.factory";
import PlannerDriverPlanOrder from "./order/planner-driver-plan-order";
import PlannerDriverPlanOrderError from "./order/planner-driver-plan-order-error";
import PlannerDriverPlanOrderParams from "./order/planner-driver-plan-order-params";
import plannerDriverPlanOrderParamsFactory from "./order/planner-driver-plan-order-params.factory";
import plannerDriverPlanOrderFactory from "./order/planner-driver-plan-order.factory";

const getData = async (
  params: PlannerDriverPlanListParams,
  abortSignal: AbortSignal,
): Promise<PlannerDriverPlanList> => {
  const requestParams: PlannerDriverPlanListRequest =
    plannerRequestFactory.create(params);

  try {
    const response = await plannerApiService().getPlanList(
      requestParams,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return plannerDriverPlanListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | PlannerDriverPlanListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrder = async (
  params: PlannerDriverPlanOrderParams,
  abortSignal: AbortSignal,
): Promise<PlannerDriverPlanOrder> => {
  const request: PlannerDriverPlanOrderRequest =
    plannerDriverPlanOrderParamsFactory.create(params);

  try {
    const response = await plannerApiService().getPlanOrder(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return plannerDriverPlanOrderFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | PlannerDriverPlanOrderError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const plannerDriverPlanService = {
  getData,
  getOrder,
};

export default plannerDriverPlanService;
